import React, { useEffect, useRef } from 'react';
import MiniSite from './MiniSite';
import { CodeBlock } from './CodeBlock';
const HTMLWithScripts = ({ html }) => {
    const containerRef = useRef(null);
    useEffect(() => {
        const container = containerRef.current;
        if (!container)
            return;
        // Inject the HTML
        container.innerHTML = html;
        // Re-execute any <script> tags by replacing them with new nodes
        const scripts = Array.from(container.querySelectorAll('script'));
        for (const oldScript of scripts) {
            const newScript = document.createElement('script');
            // Copy attributes
            for (let i = 0; i < oldScript.attributes.length; i++) {
                const attr = oldScript.attributes[i];
                newScript.setAttribute(attr.name, attr.value);
            }
            // Copy inline content
            if (oldScript.textContent) {
                newScript.text = oldScript.textContent;
            }
            // Replace to trigger execution
            oldScript.parentNode?.replaceChild(newScript, oldScript);
        }
    }, [html]);
    return React.createElement("div", { ref: containerRef });
};
export const IframeEmbedding = () => {
    let url = `${window.location.origin}/ff/org_2xvQWE6viGwyWWsfH4JCmW1np0H/basic1?sig=org_2xvQWE6viGwyWWsfH4JCmW1np0H-basic1-b69e2a2fb3093deb&mode=headless&chatPath=chat-router`;
    return React.createElement("div", { className: "space-y-5" },
        React.createElement("header", null,
            React.createElement("h1", { className: "text-xl font-semibold text-gray-900" }, "Embedding"),
            React.createElement("p", { className: "text-gray-600 text-sm mt-1" }, "Embed a FluidForm in any page (or external site) using an iframe and a small helper script to auto-resize.")),
        React.createElement("section", { className: "space-y-3" },
            React.createElement("h2", { className: "text-sm font-semibold text-gray-800" }, "Iframe Snippet"),
            React.createElement(CodeBlock, { language: "html", code: `<div id="fluidform-embed-basic" style="position:relative;">
  <script src="/fluid-navigate.js"></script>
  <iframe id="fluidform-iframe-basic"
    onload="loadIframe(this)"
    src="${url}"
    width="100%"
    height="300px"
    title="Form basic"
    frameborder="0"
    scrolling="no"
    allowtransparency="true"
    style="border:1; border-style:solid; border-width:1px; background:transparent;width:100%;min-height:300px;overflow:hidden;display:block;">
  </iframe>
</div>` })),
        React.createElement("section", { className: "space-y-3" },
            React.createElement(MiniSite, null),
            React.createElement(HTMLWithScripts, { html: `<div id="fluidform-embed-basic" style="position:relative;">
  <script src="/fluid-navigate.js"></script>
  <iframe id="fluidform-iframe-basic"
    onload="loadIframe(this)"
    src="${url}"
    width="100%"
    height="300px"
    title="Form basic"
    frameborder="0"
    scrolling="no"
    allowtransparency="true"
    style="border:1; border-style:solid; border-width:1px; background:transparent;width:100%;min-height:300px;overflow:hidden;display:block;">
  </iframe>
</div>` })));
};
